import { IOption } from '@vtbhome/juicyfront/types';

export enum EditFormKeys {
    BankName = 'bank-name',
    BankPaymentAccount = 'bank-payment-account',
    BankCorrespondentAccount = 'bank-correspondent-account',
    BankBIK = 'bank-bik',
    Catalogs = 'catalogIds',
}

export interface MutateFormFields {
    [EditFormKeys.BankName]: string;
    [EditFormKeys.BankPaymentAccount]: string;
    [EditFormKeys.BankCorrespondentAccount]: string;
    [EditFormKeys.BankBIK]: string;
    [EditFormKeys.Catalogs]: IOption[];
}
